import {useMutation} from '@tanstack/react-query';
import api from 'utils/api';

async function updateUserLanguage(language) {
	return api('put', '/api/me/profile/language', null, {language});
}

function useUpdateUserLanguage() {
	const {mutateAsync, ...result} = useMutation({
		mutationFn: updateUserLanguage,
	});

	return {...result, updateUserLanguage: mutateAsync};
}

export default useUpdateUserLanguage;
